import React from 'react'

import { Header } from '@/components/FlexibleProgramPanel/Header'
import { FlexibleProgramTabs } from '@/components/FlexibleProgramPanel/Tabs'
import { Section } from '@/components/Sections/Section'
import type { CMSSectionFlexibleProgram } from '@/types/sanity'

import './SectionProgramFlexible.scss'

type SectionProgramFlexibleProps = {
  isFirstSection?: boolean
  content: CMSSectionFlexibleProgram
}

export const SectionProgramFlexible: React.FC<SectionProgramFlexibleProps> = ({
  content,
}) => {
  const { _id, header, tabs, backgroundColor } = content

  return (
    <Section id={_id} hasWrapper={false} theme={backgroundColor} size="zero">
      <div className="section-program-flexible-wrapper">
        <div className="section-program-flexible">
          <Header {...header} />
          {tabs && <FlexibleProgramTabs tabs={tabs} />}
        </div>
      </div>
    </Section>
  )
}
